import { render, staticRenderFns } from "./VesselMonitoringHatch.vue?vue&type=template&id=60369408"
import script from "./VesselMonitoringHatch.vue?vue&type=script&lang=ts"
export * from "./VesselMonitoringHatch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports